import { Utils } from 'vmf';

export const { GlobalVar } = Utils;
export const formModelInitMixin = {
    data() {
        return {
            languageCache: {},
            language: 1,
        };
    },
    watch: {
        language: function hanlder() {
            this.formModel = this.getLanguage(this.language, this.getLanguage(1, this.formModel));
        },
    },
    methods: {
        getLanguage(type, initData) {
            const { languageCache } = this;
            let val = languageCache[type];
            if (!val) {
                val = JSON.parse(JSON.stringify(initData));
                this.$set(languageCache, type, val);
            }
            return val;
        },
        updateLanguage(type, data) {
            const { languageCache } = this;
            languageCache[type] = data;
        },
        async saveLanguage(id) {
            const list = [];
            Object.keys(this.languageCache).forEach(key => {
                const data = this.getSaveData(key);
                Object.keys(data).forEach(keyItem => {
                    if (this.ignoreFieldCodes && this.ignoreFieldCodes.indexOf(keyItem) === -1) {
                        list.push({
                            tableCode: this.languageTableName,
                            dataId: id,
                            fieldCode: keyItem,
                            language: key,
                            dataTrans: data[keyItem],
                        });
                    }
                    if (this.includeFieldCodes && this.includeFieldCodes.indexOf(keyItem) !== -1) {
                        list.push({
                            tableCode: this.languageTableName,
                            dataId: id,
                            fieldCode: keyItem,
                            language: key,
                            dataTrans: data[keyItem],
                        });
                    }
                });
            });
            if (list.length !== 0) {
                this.$api.Rs.LanguageDataTrans.saveJsonList({
                    tableCode: this.languageTableName,
                    dataId: id,
                    jsonList: JSON.stringify(list),
                });
            }
        },
        getSaveData(type) {
            const data = this.getLanguage(type, {});
            return this.buildSaveData(JSON.parse(JSON.stringify(data)));
        },
        initLanguageData(id) {
            this.$api.Rs.LanguageDataTrans.getLanguageData({
                tableCode: this.languageTableName,
                dataId: id,
            }).then(json => {
                const { data } = json.data;
                Object.keys(data).forEach(key => {
                    if (key != 1) {
                        this.languageCache[key] = this.buildInitData(data[key]);
                    } /* else {
                        this.$utils.formModelMerge(this.languageCache[key], this.buildInitData(data[key]));
                    } */
                });
            });
        },
    },
    created() {
        if (+this.$route.params.id !== -1) {
            this.formModel.id = this.$route.params.id;
        }
        if (this.formModel.id) {
            // 初始化数据
            this.initLanguageData(this.formModel.id);
        } else {
            this.updateLanguage(1, this.formModel);
        }
    },
};
